import axios from "axios";
import { API_URL } from "../utils/api-config";

// Types
export interface Driver {
  _id: string;
  driverId?: string;
  firstName: string;
  lastName: string;
  licenseNumber?: string;
  licenseType?: string;
  email?: string;
  phone?: string;
  status?: "disponible" | "indisponible" | "inactif";
}

// Service pour gérer les chauffeurs
const DriverService = {
  // Récupérer tous les chauffeurs
  getAll: async (): Promise<Driver[]> => {
    try {
      const response = await axios.get(`${API_URL}/drivers`);
      const data = response.data;
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.drivers)) return data.drivers;
      return [];
    } catch (error) {
      console.error("Erreur lors de la récupération des chauffeurs:", error);
      throw error;
    }
  },

  // Récupérer un chauffeur par ID
  getById: async (id: string): Promise<Driver> => {
    try {
      const response = await axios.get(`${API_URL}/drivers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du chauffeur:", error);
      throw error;
    }
  },
};

export default DriverService;
